// PixelModal — confirmation dialog with pixel-art styling and background blur

import { useEffect } from 'preact/hooks';

interface PixelModalProps {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function PixelModal({
  title,
  message,
  confirmText = 'CONFIRMAR',
  cancelText = 'CANCELAR',
  onConfirm,
  onCancel,
}: PixelModalProps) {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onCancel();
      if (e.key === 'Enter') onConfirm();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  return (
    <div
      onClick={onCancel}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.3)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 200,
      }}
    >
      <div
        class="pixel-border"
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: '400px',
          padding: '1.5rem',
          background: 'var(--bg-panel)',
          textAlign: 'center',
        }}
      >
        <h3 class="pixel-title text-yellow mb-2" style={{ fontSize: '16px' }}>
          {title}
        </h3>
        <p class="mb-3" style={{ fontSize: '18px' }}>{message}</p>
        <div style={{ display: 'flex', gap: '0.8rem', justifyContent: 'center' }}>
          <button
            class="pixel-btn"
            onClick={onCancel}
            style={{ fontSize: '16px' }}
            onFocus={() => {}}
          >
            {cancelText}
          </button>
          <button
            class="pixel-btn text-red"
            onClick={onConfirm}
            style={{ fontSize: '16px', borderColor: 'var(--accent-red)', color: 'var(--accent-red)' }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
